import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface UserState {
    name: string;
    nickName: string;
    picture: string;
    email: string;
    emailVerified: boolean;
    streakCount: number;
    userIsoCode: string;
    phone: string;
    phoneVerified: boolean;
    callBackRequest: boolean;
    profileStatus: string;
    degreePursue: string;
    id: string;
    currentPlan: string;
    referralCode?: string | null;
    counsellorCode?: string | null;
    allReqInfoFilled?: boolean;
    allAcademicInfoFilled?: boolean;
    freeUser:boolean;
}

const initialState: UserState = {
    name: '',
    nickName: '',
    picture: '',
    email: '',
    emailVerified: false,
    streakCount: 0,
    userIsoCode: '',
    phone: '',
    phoneVerified: false,
    callBackRequest: false,
    profileStatus: '',
    degreePursue: 'master',
    id: '',
    currentPlan: '',
    referralCode: null,
    counsellorCode: null,
    allReqInfoFilled: false,
    allAcademicInfoFilled: false,
    freeUser:false
};

const userSlice = createSlice({
    name: 'userData',
    initialState,
    reducers: {
        setUserInfo(state, action: PayloadAction<UserState>) {
            return { ...state, ...action.payload };
        },
        updateUserField<K extends keyof UserState>(state: any, action: PayloadAction<{ key: K; value: UserState[K] }>) {
            state[action.payload.key] = action.payload.value;
        },
        setUserId(state, action: PayloadAction<string>) {
            state.id = action.payload;
        },
        setIsAllReInfoFilled(state, action: PayloadAction<boolean>) {
            state.allReqInfoFilled = action.payload;
        },
        setIsAllAcademicInfoFilled(state, action: PayloadAction<boolean>) {
            state.allAcademicInfoFilled = action.payload;
        },
        setCurrentPlan(state, action:PayloadAction<string>){
            state.currentPlan = action.payload;
        },
        setStreakCount(state, action: PayloadAction<number>) {
            state.streakCount = action.payload;
        },
        setIsFreeUser(state, action:PayloadAction<boolean>){
            state.freeUser = action.payload;
        },
        clearUserInfo() {
            return initialState;
        },
    },
});

export const { setUserInfo, updateUserField, setIsAllReInfoFilled, setCurrentPlan, setIsFreeUser, setIsAllAcademicInfoFilled, setStreakCount, clearUserInfo } = userSlice.actions;
export default userSlice.reducer;
